export const POLICY_MODULES = [
  {
    id: "quota_increase",
    name: "Augmentation quotas",
    category: "Performance",
    impact: { stress: +15, turnover: +12, productivity: +50 }
  },
  {
    id: "performance_bonus",
    name: "Bonus performance",
    category: "Performance",
    impact: { stress: +12, turnover: +10, productivity: +48 }
  },
  {
    id: "overtime_mandatory",
    name: "Heures sup obligatoires",
    category: "Performance",
    impact: { stress: +50, turnover: +40, productivity: +12 }
  },
  {
    id: "surveillance_247",
    name: "Surveillance 24/7",
    category: "Contrôle",
    impact: { stress: +55, turnover: +45, productivity: -30 }
  },
  {
    id: "vacation_cut",
    name: "Réduction congés",
    category: "Restriction",
    impact: { stress: -10, turnover: -8, productivity: +15 } 
  },
  {
    id: "late_penalties",
    name: "Pénalités retard",
    category: "Restriction",
    impact: { stress: +40, turnover: +35, productivity: +3 } // ❌ Très pénalisant
  }
];

export const POLICIES = POLICY_MODULES;

export function calculateCombinedMetrics(moduleIds) {
  const baseline = { stress: 3, turnover: 2, productivity: 10 };

  const combined = moduleIds.reduce((acc, id) => {
    const module = POLICY_MODULES.find(m => m.id === id);
    if (!module) return acc;

    return {
      stress: acc.stress + module.impact.stress,
      turnover: acc.turnover + module.impact.turnover,
      productivity: acc.productivity + module.impact.productivity,
    };
  }, baseline);

  return {
    stress: Math.max(0, Math.min(100, combined.stress)),
    turnover: Math.max(0, Math.min(100, combined.turnover)),
    productivity: Math.max(0, Math.min(100, combined.productivity)),
  };
}

export function generateProjection(metrics) {
  const months = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin"];

  return months.map((month, i) => {
    const stressGrowth = metrics.stress + (i * 0.8);
    const turnoverGrowth = metrics.turnover + (i * 0.6);
    const productivityDecay = metrics.productivity - (i * 0.2);

    return {
      month,
      stress: Math.min(100, stressGrowth),
      turnover: Math.min(100, turnoverGrowth),
      productivity: Math.max(10, productivityDecay),
    };
  });
}

export const OPTIMAL_COMBINATION = [
  "quota_increase",
  "performance_bonus",
  "vacation_cut"
];

export function isOptimalCombination(moduleIds) {
  const sorted1 = [...moduleIds].sort();
  const sorted2 = [...OPTIMAL_COMBINATION].sort();
  return JSON.stringify(sorted1) === JSON.stringify(sorted2);
}